import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import "./AddSearchMuiScopedCssBaselineHide.css";
import { cx } from "@emotion/css";
import { useMediaQuery, useTheme } from "@mui/material";
import $ from "jquery";
import { useEffect, useRef, useState } from "react";
import URI from "urijs";
import { isNotUndefined, trackNullSearchResults, trackSearchEvents } from "../FunctionsCore";
import { LoadingState, useDidUpdateEffect, useFocus } from "../Internal";
import { classCombinerFromPrefix } from "../RenderIdentifier";
import { getSiteContentAddSearch, initAddSearchClient, sendClickEventAddSearch } from "./AddSearch/api/AddSearchAPI";
import { FilterComponent } from "./AddSearch/FilterComponent";
import { Pagination } from "./AddSearch/Pagination";
import { ResultsComponent } from "./AddSearch/ResultsComponent";
import { getPageNumberFragmentParameterName, getSearchFragmentParameterName, LoadingIndicator, singlePageSearchSharedClassCombiner, singlePageSearchSharedStyles } from "./SinglePageSearchShared";
import TabSiteContentAddSearchStylesModuleScssModule from "./TabSiteContentAddSearchStyles.module.scss";
const tabSiteContentAddSearchStyles = TabSiteContentAddSearchStylesModuleScssModule;
const tabClassCombiner = classCombinerFromPrefix("d3c75d6bb4ebd8f7");
const TabSiteContentAddSearchContentsComponent = (props) => {
    var _a, _b;
    const { activeTab, inTabAll, isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage, isSearchOverlay, isSearchOverlayAndNotUnitedStates, isSearchOverlayOpen, isSiteSearchResultsPage, searchInput, setSearchInput, singlePageSearchData, tabAllSearchValue, useFragmentAndUrlState } = props;
    const { addSearchPublicSiteKey, clearAllLocalized, filterByLocalized, noSearchResultsSiteContentPrefix, noSearchResultsSiteContentSuffix, siteSearchPathRewritten } = singlePageSearchData;
    const mobileBreakpoint = 992;
    const [focusReference, doFocus] = useFocus();
    const searchResultsContainerReference = useRef(null);
    const [loadingState, setLoadingState] = useState(LoadingState.Initial);
    const [scrollToSearchResultsContainer, setScrollToSearchResultsContainer] = useState(false);
    const [siteSearchResponse, setSiteSearchResponse] = useState();
    const [filterObject, setFilterObject] = useState({ "or": [] });
    const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
    const thisTab = "Site Content";
    const [pageNumberString, setPageNumberString] = useFragmentAndUrlState(getPageNumberFragmentParameterName(thisTab), "1");
    const [searchValue, setSearchValue] = useFragmentAndUrlState(getSearchFragmentParameterName(thisTab), "");
    const [pageNumber, setPageNumber] = [window.Number.parseInt(pageNumberString), (number) => setPageNumberString(number.toString())];
    const [resultsPerPage, setResultsPerPage] = useState(10);
    useEffect(() => {
        if (isSearchOverlay && isSearchOverlayOpen && activeTab === thisTab) {
            doFocus();
        }
    }, [isSearchOverlay, isSearchOverlayOpen, activeTab]);
    useEffect(() => {
        if (isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage && !isSearchOverlay && activeTab === thisTab) {
            doFocus();
        }
    }, [activeTab, isSearchOverlay]);
    useDidUpdateEffect(() => {
        if (!isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage && !isSearchOverlay && activeTab === thisTab) {
            doFocus();
        }
    }, [activeTab, isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage, isSearchOverlay]);
    useEffect(() => {
        if (searchValue.length > 0) {
            setSearchInput(searchValue);
        }
    }, []);
    useDidUpdateEffect(() => {
        if (!isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage && !isSearchOverlay) {
            setPageNumber(1);
        }
    }, [searchValue]);
    useEffect(() => {
        if (isNotUndefined(tabAllSearchValue)) {
            setSearchInput(tabAllSearchValue);
            setSearchValue(tabAllSearchValue);
        }
    }, [tabAllSearchValue]);
    const handleSiteSearchResponse = (si) => {
        setLoadingState(LoadingState.Completed);
        setSiteSearchResponse(si);
        if (scrollToSearchResultsContainer) {
            const current = searchResultsContainerReference.current;
            if (current !== null) {
                const $window = $(window);
                $window.scrollTop($(current).offset().top - $window.height() / 2);
            }
            setScrollToSearchResultsContainer(false);
        }
        if (si.siteContentCards.length === 0) {
            trackNullSearchResults();
        }
    };
    const addSearchClient = initAddSearchClient({
        "addSearchPublicSiteKey": addSearchPublicSiteKey,
        "pageNumber": pageNumber,
        "resultsPerPage": resultsPerPage
    });
    const handleSearchResultClick = ({ addSearchResultInfo }) => {
        sendClickEventAddSearch({
            "addSearchClient": addSearchClient,
            "addSearchResultInfo": addSearchResultInfo
        });
    };
    useEffect(() => {
        if (!isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage && !isSearchOverlay && ((inTabAll && activeTab === "All") || (!inTabAll && activeTab === thisTab))) {
            if (searchValue.length > 0) {
                setLoadingState(LoadingState.InProgress);
                getSiteContentAddSearch({
                    "addSearchClient": addSearchClient,
                    "filterObject": filterObject,
                    "handleSearchResults": handleSiteSearchResponse,
                    "resultsPerPage": resultsPerPage,
                    "searchTerm": searchValue
                });
            }
            else {
                setLoadingState(LoadingState.Completed);
                setPageNumber(1);
                setSiteSearchResponse(void 0);
            }
        }
    }, [pageNumber, activeTab, inTabAll, isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage, isSearchOverlay, searchValue, filterObject, resultsPerPage]);
    useEffect(() => {
        if (!isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage && !isSearchOverlay && activeTab === thisTab && searchInput.length > 0) {
            setSearchValue(searchInput);
        }
    }, [activeTab, isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage, isSearchOverlay]);
    const setSearchValueFunction = () => {
        if (isSearchOverlayAndNotUnitedStates) {
            // TODO Hack
            window.location.href = URI(siteSearchPathRewritten)
                .query({
                "q": searchInput,
            })
                .toString();
        }
        else {
            setSearchValue(searchInput);
        }
        trackSearchEvents(activeTab, searchInput);
    };
    const updatePagination = (paginationData) => {
        setPageNumber(paginationData.currentPage);
        setResultsPerPage(paginationData.perPage);
        setScrollToSearchResultsContainer(true);
    };
    const updateFilters = (fo) => {
        if (pageNumber > 1) {
            setPageNumber(1);
        }
        setFilterObject(fo);
        setScrollToSearchResultsContainer(true);
    };
    const theme = useTheme();
    const mobile = !useMediaQuery(theme.breakpoints.up(mobileBreakpoint));
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, isSearchOverlay || (isSiteSearchResultsPage && searchValue.length === 0)
                    ? "tabNameWrapper"
                    : "tabNameWrapperWithoutBorderRadius")) }, { children: _jsx("div", Object.assign({ className: cx(tabClassCombiner(singlePageSearchSharedStyles, "search-flex-container")) }, { children: _jsxs("div", Object.assign({ className: cx(tabClassCombiner(singlePageSearchSharedStyles, "input-icon-container"), tabClassCombiner(singlePageSearchSharedStyles, "text-box-style")) }, { children: [_jsxs("div", Object.assign({ className: cx(tabClassCombiner(singlePageSearchSharedStyles, "text-field-container")) }, { children: [_jsx("input", { className: cx(tabClassCombiner(singlePageSearchSharedStyles, "input-with-icon"), tabClassCombiner(singlePageSearchSharedStyles, "single-input-icon")), onChange: (ch) => setSearchInput(ch.target.value), onKeyPress: (ke) => {
                                            if (ke.key === "Enter") {
                                                setSearchValueFunction();
                                            }
                                        }, placeholder: (_a = singlePageSearchData.searchhereLocalized) !== null && _a !== void 0 ? _a : "Search here...", ref: focusReference, type: "text", value: searchInput }), isNotUndefined(searchInput) && searchInput.length > 0 ?
                                        _jsx("button", { "aria-label": "close", className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "close-icon")), onClick: () => setSearchInput(""), type: "button" }) : _jsx(_Fragment, {})] })), _jsx("div", { children: _jsx("button", Object.assign({ className: cx(tabClassCombiner(singlePageSearchSharedStyles, "search-btn")), onClick: setSearchValueFunction, type: "button" }, { children: (_b = singlePageSearchData.searchLocalized) !== null && _b !== void 0 ? _b : "Search" })) })] })) })) })), _jsxs("div", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "contentWrapper"), singlePageSearchSharedClassCombiner(tabSiteContentAddSearchStyles, "AddSearch"), singlePageSearchSharedClassCombiner(tabSiteContentAddSearchStyles, `isSearchOverlay-${isSearchOverlay}`)), ref: searchResultsContainerReference }, { children: [isSearchOverlayOpen ? (_jsx(_Fragment, {})) : (_jsx(FilterComponent, { activeFilter: filterObject, clearAllLocalized: clearAllLocalized, filterByLocalized: filterByLocalized, mobileOpen: mobileFiltersOpen, setMobileFiltersOpen: setMobileFiltersOpen, updateFilter: updateFilters })), !isSearchOverlayOpen && (loadingState === LoadingState.Initial || loadingState === LoadingState.InProgress)
                        ? (_jsx("div", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(tabSiteContentAddSearchStyles, "LoadingIndicator")) }, { children: _jsx(LoadingIndicator, { loadingState: LoadingState.InProgress }) }))) : (isNotUndefined(siteSearchResponse) ? (_jsxs("div", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(tabSiteContentAddSearchStyles, "ResultsAndPagination")) }, { children: [_jsx(ResultsComponent, Object.assign({}, props, { handleSearchResultClick: handleSearchResultClick, mobileFiltersOpen: mobileFiltersOpen, setMobileFiltersOpen: setMobileFiltersOpen, siteSearchResponse: siteSearchResponse })), siteSearchResponse.siteContentCards.length > 0
                                ? (_jsx(_Fragment, {})) : (_jsxs("div", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "noResultBox")) }, { children: [noSearchResultsSiteContentPrefix !== null && noSearchResultsSiteContentPrefix !== void 0 ? noSearchResultsSiteContentPrefix : "There are no search results for", " ", "\"", searchValue, "\"", " ", noSearchResultsSiteContentSuffix !== null && noSearchResultsSiteContentSuffix !== void 0 ? noSearchResultsSiteContentSuffix : "within Site Content."] }))), (mobileFiltersOpen && mobile) || siteSearchResponse.totalMatchedResults === 0 ? (_jsx(_Fragment, {})) : (_jsx(Pagination, { currentPage: pageNumber, perPage: resultsPerPage, totalResults: siteSearchResponse.totalMatchedResults, updatePagination: updatePagination }))] }))) : (_jsx(_Fragment, {})))] }))] }));
};
const TabSiteContentAddSearchContentsForAllTabComponent = (properties) => _jsx(TabSiteContentAddSearchContentsComponent, Object.assign({}, properties, { inTabAll: true }));
const TabSiteContentAddSearchContentsNotForAllTabComponent = (properties) => _jsx(TabSiteContentAddSearchContentsComponent, Object.assign({}, properties, { inTabAll: false }));
export { TabSiteContentAddSearchContentsForAllTabComponent, TabSiteContentAddSearchContentsNotForAllTabComponent };
